import React from 'react';
import PropTypes from 'prop-types';
import cn from 'src/classnames';
import styles from './TitledDescription.module.scss';
import { colors } from '../../constants/styleConstants';
import { Tag } from '../DynamicTag';

const TitledDescription = ({ title, description, descColor, size, color, tagName = 'h2' }) => (
  <article className={styles.wrapper}>
    <Tag
      className={cn(styles.title, {
        [styles.white]: color === 'white',
        [styles.small]: size === 'small',
        [styles.extraLarge]: size === 'extraLarge',
        [styles.customLargeTitle]: size === 'customLargeTitle',
      })}
      tagName={tagName}
    >
      {title}
    </Tag>
    {description && (
      <p style={{ color: colors[descColor] }} className={styles.description}>
        {description}
      </p>
    )}
  </article>
);

TitledDescription.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  descColor: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
};

export default TitledDescription;
